import { Slider, Stack } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { uiColors } from '../../common/styles';

const StyledSlider = styled(Slider)`
    height: 8px;

    &&.MuiSlider-root {
        color: ${props => props.$color || uiColors.GRAY_800};
    }

    .MuiSlider-thumb {
        background-color: ${uiColors.PRIMARY_0};
        border: 7px solid ${uiColors.PRIMARY};

        &:focus,
        &:hover,
        &.MuiSlider-active {
            box-shadow: inherit;
        }
    }

    .MuiSlider-valueLabel {
        top: -15px;

        & * {
            background: transparent;
        }
    }

    .MuiSlider-track {
        height: 6px;
        border-radius: 4px;
        background-color: ${uiColors.PRIMARY_200};
        border: none;
    }

    .MuiSlider-rail {
        height: 4px;
        border-radius: 4px;
    }
`;

const StyledStack = styled(Stack)`
    justify-content: center;
`;

const FramiSlider = (props) => {
    return (
        <StyledStack
            spacing={2}
            sx={{ marginTop: props?.sx?.marginTop, marginBottom: props?.sx?.marginBottom }}
            direction="row"
            alignItems="center"
        >
            {props.$leftIcon}
            <StyledSlider {...props} />
            {props.rightIcon}
        </StyledStack>
    );
};

export default FramiSlider;
